const BASE = process.env.PUBLIC_URL || "";

// variant "light" = for cream/white backgrounds, "dark" = for ink backgrounds.
export const BrandLogo = ({ className = "h-10", variant = "light", testid = "brand-logo" }) => (
  <img src={`${BASE}/brand/logo-${variant}.webp`} alt="O Seu Chamador" data-testid={testid}
    className={`${className} w-auto select-none`} draggable="false" />
);

export const BrandIcon = ({ className = "w-9 h-9", style, testid = "brand-icon" }) => (
  <img src={`${BASE}/brand/logo-icon.png`} alt="O Seu Chamador" data-testid={testid} style={style}
    className={`${className} rounded-md object-cover select-none`} draggable="false" />
);
